import { useSelector } from 'react-redux';
import { Outlet, useNavigate } from 'react-router-dom';

function UserManagement() {
  const navigate = useNavigate();
  const { role } = useSelector((state) => state.auth);
  if (role !== 'admin') {
    navigate('/');
  }
  return (
    <div className="page-header">
      <Outlet />
    </div>
  );
}

export default UserManagement;
